import ace from 'ace-builds';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/theme-dawn';
import 'ace-builds/src-noconflict/ext-searchbox';
import 'ace-builds/src-noconflict/ext-language_tools';
// HTML worker for syntax validation
import 'ace-builds/src-noconflict/worker-html';

export const aceLoader = (): Promise<typeof ace> => {
  // Configure ace to use workers for syntax validation
  ace.config.set('workerPath', '/node_modules/ace-builds/src-noconflict');
  ace.config.set('modePath', '/node_modules/ace-builds/src-noconflict');
  ace.config.set('themePath', '/node_modules/ace-builds/src-noconflict');

  return Promise.resolve(ace);
};
